/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SpeakerNone(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M155.51465,24.81637a7.99655,7.99655,0,0,0-8.42578.87207L77.25488,80.0029H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224.0029v-192A7.99972,7.99972,0,0,0,155.51465,24.81637ZM32,96.0029H71.9707v64H32Z" />
    </Svg>
  );
}

export default SpeakerNone;
